import React, { useContext } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import { splitIntoChunks } from '@/common/immutable/utils';
import { TipCell, TipRow } from '../../NikeOneCommon';
import { fireGAEvent, togglePickAction } from '@/analytics';
import { CURRENT_PAGE } from 'nike-ui/src/common/routing';
import { formatOdds } from '@/common/client';
import { isLoggedIn } from '@/account';
import { normalizeBetId, normalizeLiveSelection } from '../../domain/sportevent';
import { togglePick } from '@/betslip/handlers';
import BetLocationContext from 'nike-ui/src/common/BetLocationContext';
import { activeMatchSelectionHasTicket } from '@/mytickets/active/subs';
import { fromJS } from 'immutable';
import { localizeMap } from 'nike-ui/src/components/turboLive/utils';
import { getPickId, isPickSelected$$ } from 'nike-ui/src/components/betslip/subs';

export function BetSelections({ eventId, betId, delayed, tableSize, showTickets }) {
    const derefSub = useReframe();
    const bet = derefSub(['nikeone.live.bet', eventId, betId]);
    return splitIntoChunks(bet.get('odds').filter(Boolean), tableSize)
        .map(row => (
            <TipRow key={row.map(r => r.get('tip')).join('')}>
                {row.map(odd => (
                    <BetSelectionContainer
                        selection={odd}
                        key={betId + odd.get('tip')}
                        betId={betId}
                        paused={bet.get('status') === 'VYPISANA_POZASTAVENA'}
                        betNumber={bet.get('number')}
                        delayed={delayed}
                        showTickets={showTickets}
                    />
                ))}
            </TipRow>
        ))
        .toArray();
}

export function BetSelectionsTlv({ bet, delayed, tableSize, showTickets }) {
    return splitIntoChunks(fromJS(bet.selections), tableSize).map(row => (
        <TipRow key={row.map(r => r.get('code')).join('')}>
            {row.map(odd => (
                <BetSelectionContainer
                    selection={odd}
                    key={bet.id + odd.get('code')}
                    betId={bet.id}
                    paused={bet.state === 'VYPISANA_POZASTAVENA'}
                    betNumber={bet.betNumber}
                    delayed={delayed}
                    showTickets={showTickets}
                />
            ))}
        </TipRow>
    ));
}

export function BetSelectionContainer({
    selection,
    betId,
    paused,
    betNumber,
    delayed,
    showTickets,
    disableRemovePick
}) {
    const { subscribe } = useReframe();
    const betLocationContext = useContext(BetLocationContext);
    const odds = selection.get('odds');
    const name = selection.get('name');
    const header = typeof name === 'string' ? name : localizeMap(name) || '';
    const tip = selection.get('tip') || String(selection.get('code'));

    const { isSelected } = subscribe(isPickSelected$$(getPickId(betId, tip)));
    const selectionHasTicket =
        showTickets &&
        isLoggedIn() &&
        subscribe(activeMatchSelectionHasTicket(normalizeBetId(betId), normalizeLiveSelection(tip)));
    const isInvalid = odds === 1.0;
    const disabledUnselect = isSelected && disableRemovePick;
    const disabled = isInvalid || delayed || disabledUnselect;

    const classes = {
        locked: isInvalid,
        disabled: disabled,
        disabledState: paused,
        selected: isSelected,
        ripple: !paused,
        'on-ticket': selectionHasTicket,
        'on-ticket-live': selectionHasTicket
    };

    return (
        <TipCell
            classes={classes}
            onClick={() =>
                handleTogglePick(betId, tip, odds, betNumber, isSelected, betLocationContext.betLocationSection)
            }
            label={header}
            locked={isInvalid}
            odds={() => <DynamicOdds odds={odds} />}
        />
    );
}

function handleTogglePick(betId, tip, odds, betNumber, isSelected, sectionOrigin) {
    const convertSelectionCode = isNaN(tip) || parseInt(tip) < 49;
    const pick = {
        betId,
        selectionCode: convertSelectionCode ? tip?.charCodeAt(0) : tip,
        odds: odds,
        infoNumber: betNumber,
        positionId: sectionOrigin?.id,
        positionCode: sectionOrigin?.code
    };
    fireGAEvent(CURRENT_PAGE, togglePickAction(isSelected));
    dispatch(togglePick(pick));
}

class DynamicOdds extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { clazz: '' };
        this.scheduleReset = this.scheduleReset.bind(this);
    }

    scheduleReset() {
        clearTimeout(this.reset);
        this.reset = setTimeout(() => {
            this.setState({ clazz: '' });
        }, 3000);
    }

    componentDidUpdate(prevProps) {
        if (this.props.odds < prevProps.odds) {
            this.setState({ clazz: 'decrease' });
            this.scheduleReset();
        }
        if (this.props.odds > prevProps.odds) {
            this.setState({ clazz: 'increase' });
            this.scheduleReset();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.reset);
    }

    render() {
        return <span className={'kurz ' + this.state.clazz}>{formatOdds(this.props.odds)}</span>;
    }
}
